'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var FieldRequiredIndicator = require('./FieldRequiredIndicator.js');

var Label = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, fieldId = _a.fieldId, showOptional = _a.showOptional, showRequired = _a.showRequired, props = tslib.__rest(_a, ["children", "className", "fieldId", "showOptional", "showRequired"]);
    return (jsxRuntime.jsxs("label", tslib.__assign({ htmlFor: fieldId, id: fieldId ? "".concat(fieldId, "Label") : '', className: className }, props, { children: [children, (showRequired || showOptional) && (jsxRuntime.jsx(FieldRequiredIndicator.default, { showOptional: showOptional, showRequired: showRequired }))] })));
};
var Label$1 = Label;

exports.default = Label$1;
//# sourceMappingURL=Label.js.map
